<div class="container-fluid cw-background">
  <mat-card class="mat-elevation-z8 mt-3 mb-5">
    <mat-card-title class="title-page">Company Attachments List</mat-card-title>
    <mat-card-content class="mt-4">
      <div class="container-fluid">
        <app-data-table
          *ngIf="companyAttachmentsTableConfig"
          [config]="companyAttachmentsTableConfig"
          (getData)="companyAttachmentTableService.getCompanyAttachments($event)"
          (updateData)="companyAttachmentTableService.update($event)"
        ></app-data-table>
      </div>
    </mat-card-content>
  </mat-card>
</div>
